import moment from "moment";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import LocationTreeCheckboxComponent from "../../components/location/location-tree-checkbox.component";
import MultiSelectComponent from "../../components/multi-select/multi-select.component";
import paginationComponent from "../../components/pagination/pagination.component";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import SelectSiteComponent from "../../components/site/select-site.component";
import VocWidgetComponent from "../../components/widget/voc-widget.component";
import { formats as FORMATS, codeMasterType } from "../../config/constants";
import codeMasterModel from "../../models/common/code-master.model";
import languageModel from "../../models/language.model";
import loginModel from "../../models/login.model";
import vocModel from "../../models/voc/voc.model";
import VocConfig from "../../utils/voc-config";
import ViewBase from "../view-base.view";
import VocDetailView from './voc.details.view';
import VocsListItemView from "./voc.list.item.view";

export default function VocsListView() {
  ViewBase.call(this);

  let selectedVocId;
  let isShowingVocDetailPage = false;
  let isDownloadingExcel = false;
  let isDownloadingPpt = false;
  let vocConfig = new VocConfig();
  let vocList = [];
  let vocSummary;
  let gscmDivList = [];
  let vocCategoryList = [];
  let vocSubcategoryList = [];
  let vocItemList = [];
  let vocStatusList = [];
  let vocUrgencyList = [];
  let userRoleList = [];
  let selectedGscmDivList = [];
  let selectedVocCategoryList = [];
  let selectedVocSubcategoryList = [];
  let selectedVocItemList = [];
  let selectedVocStatusList = [];
  let selectedVocUrgency = null;
  let selectedVocLocationList = [];
  let selectedVocUserRoleList = [];
  let checkedAll = false;
  let sortOptions = [
    { code: 0, get name() { return languageModel.getText("LT00000369", "Updated Date: Latest first") }, sortBy: 'LastUpdateDate', order: 'DESC' },
    { code: 1, get name() { return languageModel.getText("LT00000370", "Updated Date: Oldest first") }, sortBy: 'LastUpdateDate', order: 'ASC' },
    { code: 2, get name() { return languageModel.getText("LT00000371", "VOC Title: A - Z") }, sortBy: 'Title', order: 'ASC' },
    { code: 3, get name() { return languageModel.getText("LT00000372", "VOC Title: Z - A") }, sortBy: 'Title', order: 'DESC' },
  ];
  let selectedSortOption = sortOptions[0];
  let selectedSortIndex = 0;
  let selectedSiteList = [];
  let checkSelectedAll = () => {
    let arr = vocList.filter(x => x.checked == false);
    if (arr.length > 0) {
      checkedAll = false;
    }
    else {
      checkedAll = true;
    }
  }
  let filterParams = {
    gscmDiv: '',
    category: '',
    subCategory: '',
    item: '',
    fromDate: moment().add(-6, 'w').format(FORMATS.apiDateFormat),
    toDate: moment().format(FORMATS.apiDateFormat),
    locations: '',
    userRoles: '',
    sortBy: selectedSortOption.sortBy,
    orderBy: selectedSortOption.order,
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0
  }

  let lastSearchedFilterParams = {};
  Object.assign(lastSearchedFilterParams, filterParams);

  let showVocDetailPage = (vocId) => {
    selectedVocId = vocId;
    isShowingVocDetailPage = true;
  };

  let hideVocDetailPage = () => {
    isShowingVocDetailPage = false;
    selectedVocId = undefined;
  }
  let _checkedAll = (e) => {
    checkedAll = e.target.checked;
    vocList.forEach((element) => {
      element["checked"] = checkedAll;

    });
  }
  let getVocList = () => {
    this.showLoading();
    vocList = [];
    vocModel.getVocList(
      (result) => {
        lastSearchedFilterParams = {};
        Object.assign(lastSearchedFilterParams, filterParams);
        filterParams.pageIndex = result.pageIndex;
        filterParams.pageSize = result.pageSize;
        filterParams.totalCount = result.total;
        result.data.forEach((element, index) => {
          element["rowId"] = index;
          element["checked"] = checkedAll;
          vocList.push(element);
        });
        this.hideLoading();
      },
      (error) => {
        this.hideLoading();
        this.handleError(error);
      },
      filterParams
    );
  };

  let getVocSummary = () => {
    vocSummary = undefined;
    vocModel.getVocSummary(
      (result) => {
        vocSummary = result;
      },
      (error) => {
        this.handleError(error);
      },
      filterParams
    );
  };

  let getAllVocCategoryConfigList = () => {
    vocModel.getAllVocCategoryConfigList(
      (result) => {
        vocConfig.all = result;
        getVocGscmDivisions();
        getVocCategories();
        getVocSubcategories();
        getVocItems();
      },
      (error) => {
        this.handleError(error);
      }
    );
  };

  let getVocGscmDivisions = () => {
    gscmDivList = vocConfig.gscmDivisions;
    // console.log('gscmDivList: ', gscmDivList);
  }

  let getVocCategories = () => {
    vocCategoryList = vocConfig.categories;
    // console.log('categories: ', vocCategoryList);
  }

  let getVocSubcategories = () => {
    vocSubcategoryList = vocConfig.subcategories;
    // console.log('subcategories: ', vocSubcategoryList);
  }

  let getVocItems = () => {
    vocItemList = vocConfig.items;
    // console.log('items: ', vocItemList);
  }

  let getVocStatusList = () => {
    vocModel.getVocStatusList(
      (result) => {
        // console.log('getVocStatusList: result -', result)
        vocStatusList = result;
      },
      (error) => {
        this.handleError(error);
      }
    );
  };

  let getVocUrgencyList = () => {
    vocUrgencyList = [];
    vocModel.getVocUrgencyList(
      (result) => {
        // console.log('getVocUrgencyList: result -', result)
        if (!result || result.length < 1) {
          return
        }

        result.map(r => {
          vocUrgencyList.push({ ...r })
        })
      },
      (error) => {
        this.handleError(error);
      }
    );
  };

  let getUserRoles = () => {
    codeMasterModel.getByCategoryV2({ category: codeMasterType.userRole, country: loginModel.credentials.country })
      .then((result) => {
        userRoleList = result;
      })
      .catch((error) => {
        this.handleError(error);
      })
  }

  let _searchVoc = () => {
    filterParams.pageIndex = 1; // Always go back to page 1 
    getVocList();
    getVocSummary();
  }

  let _clearFilter = () => {
    filterParams = {
      filter: '',
      fromDate: moment().add(-6, 'w').format(FORMATS.apiDateFormat),
      toDate: moment().format(FORMATS.apiDateFormat),
      sortBy: selectedSortOption.sortBy,
      orderBy: selectedSortOption.order,
      pageIndex: 1,
    }

    // Clear selections
    vocConfig.resetFilter();
    selectedGscmDivList = [];
    selectedVocCategoryList = [];
    selectedVocSubcategoryList = [];
    selectedVocItemList = [];
    selectedVocStatusList = [];
    selectedVocUrgency = null;
    selectedSiteList = [];
    selectedVocUserRoleList = [];
    selectedVocLocationList = [];

    // Reload data
    getVocList();
    getVocSummary();
    getVocGscmDivisions();
    getVocCategories();
    getVocSubcategories();
    getVocItems();
  }

  let _downloadExcel = (e) => {
    e.preventDefault();
    let arr = vocList.filter(x => x.checked);

    if (arr.length > 0) {
      let selectedList = [];
      arr.forEach(element => {
        selectedList.push(element.vocId);
      });
      lastSearchedFilterParams["vocIdList"] = selectedList;
      if (isDownloadingExcel) {
        return false;
      }
      isDownloadingExcel = true;
      vocModel.exportVocListToExcel(
        (result) => {
          isDownloadingExcel = false;
        },
        (error) => {
          isDownloadingExcel = false;
          this.handleError(error);
        },
        lastSearchedFilterParams
      );
      return false;
    } else {
      return false;
    }

  }

  let _downloadPPT = (e) => {
    e.preventDefault();
    let arr = vocList.filter(x => x.checked);
    if (arr.length > 0) {
      if (isDownloadingPpt) {
        return false;
      }
      let selectedList = [];
      arr.forEach(element => {
        selectedList.push(element.vocId);
      });
      lastSearchedFilterParams["vocIdList"] = selectedList;
      isDownloadingPpt = true;
      vocModel.exportVocListToPptx(
        (result) => {
          isDownloadingPpt = false;
        },
        (error) => {
          isDownloadingPpt = false;
          this.handleError(error);
        },
        lastSearchedFilterParams
      );
      return false;
    }
    else {
      return false;
    }

  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    filterParams.pageIndex = pageIndex;
    filterParams.pageSize = pageSize;
    getVocList();
  }

  let onPageChanged = (pageIndex) => {
    filterParams.pageIndex = pageIndex;
    getVocList();
  }

  let updateFilter = (e) => {
    let prop = e.currentTarget.id;
    let value = e.currentTarget.value;
    if (prop && prop.length > 0) {
      filterParams[prop] = value
    }
  }

  let updateLocations = (locations) => {
    selectedVocLocationList = locations;
    filterParams.locations = locations.join('^');
  }

  let sortVocList = () => {
    filterParams.sortBy = selectedSortOption.sortBy
    filterParams.orderBy = selectedSortOption.order;
    filterParams.pageIndex = 1; // Go back to page 1
    getVocList();
  }

  return {
    oninit: (vnode) => {
      getVocList();
      getVocSummary();
      // Get VOC Configs to generate select option for GSCM Division | VOC Category | VOC Sub-category | VOC Item
      getAllVocCategoryConfigList();
      getVocStatusList();
      getVocUrgencyList();
      getUserRoles();
    },
    view: (vnode) => {
      return [
        m('.row',
          !isShowingVocDetailPage &&
          m('.col-12',
            // Search section
            m('.d-flex.flex-column.align-items-end.gap-2.mb-3',
              m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="false"]',
                m('i.bi.bi-filter'),
                this.getText("LT00000232", "Filter"),
              ),
              m('#search-section.collapse.w-100',
                m('.card',
                  m('.card-body',
                    m('.row.g-4.align-items-end',
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label[for=vocId]', this.getText("LT00000484", "VOC No.")),
                        m('input.form-control[id=vocId]', { onchange: updateFilter, value: filterParams.vocId })
                      ),
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label[for=title]', this.getText("LT00000485", "Title / Contents")),
                        m('input.form-control[id=title]', { onchange: updateFilter, value: filterParams.title })
                      ),
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label[for=statusCode]', this.getText("LT00000486", "VOC Status")),
                        m(MultiSelectComponent, {
                          items: vocStatusList,
                          selectedItems: selectedVocStatusList,
                          itemKey: 'group2',
                          itemValue: 'value',
                          onSelect: (s) => {
                            // console.log('Selected vocStatusList: ', JSON.parse(JSON.stringify(s)))
                            selectedVocStatusList = s;
                            filterParams.statusCode = s.map(x => x.group2).join('^');
                          }
                        }),
                      ),
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label', this.getText("LT00000070", "Date Range")),
                        m(DatePickerComponent, {
                          class: 'form-control',
                          isRange: true,
                          grid: 1,
                          calendars: 1,
                          dateStart: moment(filterParams.fromDate).format(FORMATS.dateFormat), // default date range
                          dateEnd: moment(filterParams.toDate).format(FORMATS.dateFormat), // default date range
                          readonly: true,
                          onselect: (e) => {
                            filterParams.fromDate = moment(e.detail.start).format(FORMATS.apiDateFormat);
                            filterParams.toDate = moment(e.detail.end).format(FORMATS.apiDateFormat);
                          }
                        })
                      ),
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label', this.getText("LT00000241", "GSCM Division")),
                        m(MultiSelectComponent, {
                          items: gscmDivList,
                          selectedItems: selectedGscmDivList,
                          onSelect: (s) => {
                            // console.log('Selected gscmDivList: ', JSON.parse(JSON.stringify(s)))
                            selectedGscmDivList = s;
                            vocConfig.filter.group1 = filterParams.gscmDiv = s.map(x => x.code).join('^');

                            // Clear selections
                            vocConfig.filter.group2 = filterParams.category = '';
                            vocConfig.filter.group3 = filterParams.subCategory = '';
                            filterParams.item = '';
                            selectedVocCategoryList = [];
                            selectedVocSubcategoryList = [];
                            selectedVocItemList = [];

                            // Refresh options
                            getVocCategories();
                            getVocSubcategories();
                            getVocItems();
                          }
                        }),
                      ),
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label', this.getText("LT00000487", "VOC Category")),
                        m(MultiSelectComponent, {
                          items: vocCategoryList,
                          selectedItems: selectedVocCategoryList,
                          onSelect: (s) => {
                            // console.log('Selected vocCategoryList: ', JSON.parse(JSON.stringify(s)))
                            selectedVocCategoryList = s;
                            vocConfig.filter.group2 = filterParams.category = s.map(x => x.code).join('^');

                            // Clear selections
                            vocConfig.filter.group3 = filterParams.subCategory = '';
                            filterParams.item = '';
                            selectedVocSubcategoryList = [];
                            selectedVocItemList = [];

                            // Refresh options
                            getVocSubcategories();
                            getVocItems();
                          }
                        }),
                      ),
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label', this.getText("LT00000488", "VOC Sub-category")),
                        m(MultiSelectComponent, {
                          items: vocSubcategoryList,
                          selectedItems: selectedVocSubcategoryList,
                          onSelect: (s) => {
                            // console.log('Selected vocSubcategoryList: ', JSON.parse(JSON.stringify(s)))
                            selectedVocSubcategoryList = s;
                            vocConfig.filter.group3 = filterParams.subCategory = s.map(x => x.code).join('^');

                            // Clear selections
                            filterParams.item = '';
                            selectedVocItemList = [];

                            // Refresh options
                            getVocItems();
                          }
                        }),
                      ),
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label', this.getText("LT00000489", "VOC Item")),
                        m(MultiSelectComponent, {
                          items: vocItemList,
                          selectedItems: selectedVocItemList,
                          onSelect: (s) => {
                            // console.log('Selected vocItemList: ', JSON.parse(JSON.stringify(s)))
                            selectedVocItemList = s;
                            filterParams.item = s.map(x => x.code).join('^');
                          }
                        }),
                      ),
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label[for=statusCode]', this.getText("LT00000490", "VOC Urgency")),
                        m(SingleSelectComponent, {
                          items: vocUrgencyList,
                          selectedItem: selectedVocUrgency,
                          checkmark: true,
                          filterable: false,
                          onSelect: e => {
                            // console.log('onSelect - e', e);
                            selectedVocUrgency = e;
                            filterParams.urgencyType = e.code;
                          }
                        }),
                      ),
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label', this.getText("LT00000071", "Site")),
                        m(SelectSiteComponent, {
                          selectedItemList: selectedSiteList,
                          onChange: (s) => {
                            // console.log('Selected sites - onChange: ', s)
                            selectedSiteList = s;
                            filterParams.siteId = s.map(x => x.code).join('^');
                          }
                        }),
                      ),
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label', this.getText("LT00000491", "Created By / PIC")),
                        m('input.form-control[id=userIdOrName]', {
                          onchange: updateFilter,
                          placeholder: this.getText("LT00000048", "User ID/Name"),
                          value: filterParams.userIdOrName,
                        })
                      ),
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label', this.getText('LT00000060', 'User Role')),
                        m(MultiSelectComponent, {
                          items: userRoleList,
                          selectedItems: selectedVocUserRoleList,
                          onSelect: (v) => {
                            selectedVocUserRoleList = v;
                            filterParams.userRoles = v.map(x => x.code).join('^');
                          }
                        }),
                      ),
                      m('.col-lg-3.col-md-4.col-sm-6',
                        m('label.form-label[for=locations]', this.getText('LT00000557', 'Location')),
                        m(LocationTreeCheckboxComponent, {
                          id: 'locations',
                          selectedCodes: selectedVocLocationList,
                          isLevel1Expanded: true,
                          onChange: (v) => {
                            updateLocations(v);
                          }
                        })
                      ),
                      // Search & clear buttons
                      m('.col-12.d-flex.justify-content-end.gap-2',
                        m('button.btn.btn-primary', {
                          onclick: _searchVoc
                        }, this.getText("LT00000001", "Search")),
                        m('button.btn.btn-white', {
                          onclick: _clearFilter
                        }, this.getText("LT00000031", "Clear")),
                      ),
                    ),
                  )
                ),
              ),
            ),
            // Widget Filter
            m('.mb-3',
              m(VocWidgetComponent, {
                data: vocSummary,
                selectedFilter: filterParams.filter ? filterParams.filter : '',
                onClick: filterValue => {
                  filterParams.filter = filterValue;
                  filterParams.pageIndex = 1; // Always go back to page 1 
                  getVocList();
                }
              })
            ),

            // VOC List
            m('.d-flex.justify-content-end.gap-3.mb-2',
              m('.flex-shrink-0.d-flex.align-items-center', { style: 'padding-left: 12px;' },
                m('.form-check',
                  m('input.form-check-input#select-all-survey[type=checkbox]', {
                    checked: checkedAll,
                    onchange: (e) => { _checkedAll(e) },
                    disabled: vocList.length == 0
                  }),
                  m('label.form-check-label[for=select-all-survey]', this.getText("LT00000077", "Select all"))
                ),
              ),
              m('.surveytype-legend.flex-grow-1.d-flex.flex-wrap.align-items-center.gap-3.ps-md-4.ps-lg-5.mb-1'),
              m('div',
                m(SingleSelectComponent, {
                  allowEmpty: false,
                  selectedItem: selectedSortOption,
                  items: sortOptions,
                  filterable: false,
                  onSelect: e => {
                    selectedSortIndex = sortOptions.findIndex(s => s.code === e.code);
                    selectedSortOption = sortOptions[selectedSortIndex];
                    sortVocList();
                  }
                })
              ),
              m('.input-group.w-auto',
                m('button.btn.btn-primary.dropdown-toggle.dropdown-toggle-split[type=button][data-bs-toggle=dropdown][arie-expanded=false]',
                  {
                    disabled: (vocList && vocList.length > 0) ? false : true,
                  },
                  (isDownloadingExcel || isDownloadingPpt)
                    ? m('span.spinner-border.spinner-border-sm.me-2[role=status][aria-hidden=true]')
                    : m('i.bi.bi-file-earmark-arrow-down-fill'),
                  this.getText("LT00000492", "Download")
                ),
                m('ul.dropdown-menu',
                  m('li',
                    m('a.dropdown-item[href="javascript:void(0);"]', {
                      class: isDownloadingExcel ? 'disabled' : vocList.filter(x => x.checked).length > 0 ? '' : 'disabled',
                      onclick: _downloadExcel
                    },
                      isDownloadingExcel &&
                      m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                      this.getText("LT00000493", "Excel")
                    )
                  ),
                  m('li',
                    m('a.dropdown-item[href="javascript:void(0);"]', {
                      class: isDownloadingPpt ? 'disabled' : vocList.filter(x => x.checked).length > 0 ? '' : 'disabled',
                      onclick: _downloadPPT
                    },
                      isDownloadingPpt &&
                      m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                      this.getText("LT00000494", "PPT")
                    )
                  ),
                ),
              ),
            ),
            m('.d-flex.flex-column.gap-2',
              vocList && vocList.length > 0 &&
              vocList.map((voc) => [
                m(VocsListItemView, {
                  voc: voc,
                  checkedAll: checkedAll,
                  onClick: showVocDetailPage,
                  checkedChanged: checkSelectedAll
                })
              ])
            ),
            m(".mt-3",
              m(paginationComponent, {
                currentPage: filterParams.pageIndex,
                pageSize: filterParams.pageSize,
                totalItems: filterParams.totalCount,
                onPageChanged: onPageChanged,
                onPageSizeChanged: onPageSizeChanged
              })
            )
          ),
          isShowingVocDetailPage &&
          m(VocDetailView, {
            vocId: selectedVocId,
            hideVocDetailPage: hideVocDetailPage
          }),
        ),
        this.getBaseViews()
      ]
    }
  }
}
